export default __webpack_public_path__ + "static/media/hero.37638e08.webp";